import dayjs, { Dayjs } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import weekday from 'dayjs/plugin/weekday'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrBefore)
dayjs.extend(weekday)
dayjs.extend(customParseFormat)

export default dayjs

export type DayjsInput = string | number | Date | Dayjs | (string | number | Date | Dayjs)[]

export const getDayjsFormat = (input: string | string[] | undefined) => {
  if (typeof input == 'string') {
    return input
  } else if (Array.isArray(input)) {
    return input.join('-')
  }
  return ''
}
